// src/lib/custom-ui/haptics/haptics.ts
import { APP_INTERFACE_SETTINGS } from "../app-interface-config";

export const triggerHaptic = (duration: number = 10) => {
  if (typeof window === "undefined") return;

  // 1. Проверка вашего ручного "Пульта" (app-interface-config.ts)
  if (!APP_INTERFACE_SETTINGS.vibrationEnabled) return;

  const canVibrate = !!(window.navigator && window.navigator.vibrate);
  
  if (canVibrate) {
    // 2. Проверка выбора пользователя (localStorage)
    const savedSetting = localStorage.getItem("user_haptic_enabled");
    const isUserEnabled = savedSetting !== "false"; 

    if (isUserEnabled) {
      window.navigator.vibrate(duration);
    }
  }
};